import { IonInput, IonItem, IonLabel } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormTitle: React.FC<Props> = (props) => {
  return (
    <IonItem>
      <IonLabel position="floating">Titel</IonLabel>
      <IonInput value={props.value} onIonChange={e => props.onChange((e.target as HTMLInputElement).value)} />
    </IonItem>
  )
}

export default FormTitle
